module.exports = __webpack_public_path__ + "img/CC.41bbfcb7.jpg";